import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="reveal-phone"
export default class extends Controller {
  static values = { phone: String };
  static targets = ["destination", "template"];

  handle() {
    const content = this.destinationTarget.innerHTML;
    this.destinationTarget.innerHTML = this.templateTarget.innerHTML.replaceAll(
      "PHONE",
      this.phoneValue,
    );

    setTimeout(() => {
      this.destinationTarget.innerHTML = content;
    }, 6000);
  }
}
